"use client";

import { useState, useEffect } from "react";
import moment from "moment";
import { TAGS } from "./constants";
import CalendarView from "./CalendarView";
import SummaryView from "./SummaryView";
import { LuCalendarDays, LuChartBar, LuFileSpreadsheet } from "react-icons/lu";

import { fetchTimelogsByMonth, fetchTimelogsByDateRange } from "./services";

export default function TimelogTracker() {
  const [activeTab, setActiveTab] = useState("calendar");
  const [timelogs, setTimelogs] = useState([]);

  // Summary date range

  // Load monthly data initially (Calendar default)
  useEffect(() => {
    async function loadInitial() {
      const year = moment().year();
      const month = moment().month();
      const data = await fetchTimelogsByMonth(year, month);
      setTimelogs(data);
    }
    loadInitial();
  }, []);

  return (
    <div className="min-h-screen bg-slate-50 p-4 ">
      <div className="mx-auto max-w-7xl">
        {/* Tabs */}
        <div className="mb-4 flex gap-2 border-b border-slate-200">
          <button
            onClick={() => setActiveTab("calendar")}
            className={`px-4 py-2 font-medium transition-colors flex gap-2 items-center ${
              activeTab === "calendar"
                ? "border-b-2 border-blue-600 text-blue-600"
                : "text-slate-600 hover:text-slate-900"
            }`}
          >
            <LuCalendarDays size={18} /> Calendar
          </button>

          <button
            onClick={() => setActiveTab("summary")}
            className={`px-4 py-2 font-medium transition-colors flex gap-2 items-center ${
              activeTab === "summary"
                ? "border-b-2 border-blue-600 text-blue-600"
                : "text-slate-600 hover:text-slate-900"
            }`}
          >
            <LuChartBar size={18} /> Summary
          </button>
        </div>

        {activeTab === "calendar" && (
          <div className="overflow-x-auto">
            <div className="min-w-[920px] md:min-w-0">
              <CalendarView timelogs={timelogs} setTimelogs={setTimelogs} />
            </div>
          </div>
        )}

        {activeTab === "summary" && <SummaryView />}
      </div>
    </div>
  );
}
